import { useState, useEffect } from 'react';

interface ISize {
  width?: number;
  height?: number;
}

const getSize = (isClient: boolean): ISize => {
  return {
    width: isClient ? window.innerWidth : undefined,
    height: isClient ? window.innerHeight : undefined,
  };
};

export const useWindowSize = (): ISize => {
  const isClient = typeof window === 'object';

  const [windowSize, setWindowSize] = useState<ISize>(getSize(isClient));

  useEffect((): any => {
    const handleResize = (): void => {
      setWindowSize(getSize(isClient));
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isClient]);

  return windowSize;
};
